/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./bd.vue?vue&type=template&id=a85d5ce8&scoped=true&"
import script from "./bd.vue?vue&type=script&lang=ts&"
export * from "./bd.vue?vue&type=script&lang=ts&"
import style0 from "./bd.vue?vue&type=style&index=0&id=a85d5ce8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a85d5ce8",
  null
  
)

export default component.exports